import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Centers
  centers: [],
  centersLoading: false,
  centersError: null,
  selectedCenter: null,

  // Retreats (camps with Camp_Type='R')
  retreats: [],
  retreatsLoading: false,
  retreatsError: null,
  selectedRetreat: null,

  // Camp dates & accommodation fee
  campDates: null,  // { camp_Id, accommodationFee, campStartDate, campEndDate, transportFee }
  campDatesLoading: false,

  // Attendees (family members)
  unregisteredAttendees: [],
  registeredAttendees: [],
  attendeesLoading: false,
  attendeesError: null,

  // Registration tracking
  lastRegInfo: null,  // { attendeeId, registrationId }

  // Fee calculation
  calculation: null,
  calcLoading: false,

  // Payment info (passed to payment page)
  paymentInfo: null,  // { registrationId, userId, campId, totalAmount, ... }
};

const retreatSlice = createSlice({
  name: 'retreat',
  initialState,
  reducers: {
    // Centers
    setCenters: (state, action) => {
      state.centers = action.payload;
      state.centersError = null;
    },
    setCentersLoading: (state, action) => {
      state.centersLoading = action.payload;
    },
    setCentersError: (state, action) => {
      state.centersError = action.payload;
    },
    setSelectedCenter: (state, action) => {
      state.selectedCenter = action.payload;
    },

    // Retreats
    setRetreats: (state, action) => {
      state.retreats = action.payload;
      state.retreatsError = null;
    },
    setRetreatsLoading: (state, action) => {
      state.retreatsLoading = action.payload;
    },
    setRetreatsError: (state, action) => {
      state.retreatsError = action.payload;
    },
    setSelectedRetreat: (state, action) => {
      state.selectedRetreat = action.payload;
    },

    // Camp dates / accommodation
    setCampDates: (state, action) => {
      state.campDates = action.payload;
    },
    setCampDatesLoading: (state, action) => {
      state.campDatesLoading = action.payload;
    },

    // Attendees
    setUnregisteredAttendees: (state, action) => {
      state.unregisteredAttendees = action.payload;
    },
    setRegisteredAttendees: (state, action) => {
      state.registeredAttendees = action.payload;
    },
    setAttendeesLoading: (state, action) => {
      state.attendeesLoading = action.payload;
    },
    setAttendeesError: (state, action) => {
      state.attendeesError = action.payload;
    },

    // Registration
    setLastRegInfo: (state, action) => {
      state.lastRegInfo = action.payload;
    },

    // Calculation
    setCalculation: (state, action) => {
      state.calculation = action.payload;
      state.calcLoading = false;
    },
    setCalcLoading: (state, action) => {
      state.calcLoading = action.payload;
    },
    clearCalculation: (state) => {
      state.calculation = null;
    },

    // Payment info
    setPaymentInfo: (state, action) => {
      state.paymentInfo = action.payload;
    },
    clearPaymentInfo: (state) => {
      state.paymentInfo = null;
    },

    // Reset full module
    clearRetreatData: () => initialState,

    // Reset attendee/reg data when retreat changes
    clearRegistrationData: (state) => {
      state.unregisteredAttendees = [];
      state.registeredAttendees = [];
      state.attendeesError = null;
      state.lastRegInfo = null;
      state.calculation = null;
      state.paymentInfo = null;
      state.campDates = null;
    },
  },
});

export const {
  setCenters,
  setCentersLoading,
  setCentersError,
  setSelectedCenter,
  setRetreats,
  setRetreatsLoading,
  setRetreatsError,
  setSelectedRetreat,
  setCampDates,
  setCampDatesLoading,
  setUnregisteredAttendees,
  setRegisteredAttendees,
  setAttendeesLoading,
  setAttendeesError,
  setLastRegInfo,
  setCalculation,
  setCalcLoading,
  clearCalculation,
  setPaymentInfo,
  clearPaymentInfo,
  clearRetreatData,
  clearRegistrationData,
} = retreatSlice.actions;

export default retreatSlice.reducer;
